import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateStep = new ReduxAsyncAction<'UPDATE_STEP', string, { step: string }>('UPDATE_STEP');

UpdateStep.registerRequest(async (step: string) => {
  return {
    step,
  };
});

export const UPDATE_STEP = UpdateStep.actionNamespaceConstants;

export const updateStep = UpdateStep.request;

export type UpdateStepResponseAction = Action<typeof UPDATE_STEP.response> & {
  data: { step: string };
};
